import React from "react";
import Header from "../../../Header/Header";
import Footer from "../../../Footer/Footer";
import InnerPage from "./InnerPage";

const Card1 = () => {
  return (
    <>
      <Header />
      <InnerPage />
      <Footer />
    </>
  );
};

export default Card1;
